var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100ScreenOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_998_100369)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#129C49",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4732 6.20233C11.2492 5.70617 12.1544 5.4412 13.0798 5.4393C14.3512 5.44063 15.5701 5.93811 16.469 6.82259C17.368 7.70707 17.8736 8.9063 17.875 10.1571C17.875 10.324 17.8076 10.484 17.6877 10.6019C17.5678 10.7199 17.4052 10.7862 17.2356 10.7862C17.0661 10.7862 16.9035 10.7199 16.7836 10.6019C16.6636 10.484 16.5963 10.324 16.5963 10.1571C16.5972 9.55523 16.4381 8.96355 16.135 8.44074C15.8318 7.91794 15.395 7.48218 14.8679 7.17666C14.3408 6.87114 13.7417 6.70647 13.1299 6.69898C12.5182 6.69149 11.9151 6.84143 11.3804 7.13395L12.4034 8.19137C12.4432 8.23231 12.471 8.28306 12.4839 8.33826C12.4968 8.39347 12.4943 8.45108 12.4767 8.505C12.4591 8.55893 12.427 8.60718 12.3838 8.64465C12.3406 8.68212 12.288 8.70742 12.2314 8.71788L8.50331 9.40229C8.48387 9.40537 8.46417 9.40664 8.44449 9.40606C8.39644 9.40603 8.34901 9.39535 8.30574 9.3748C8.26246 9.35425 8.22445 9.32437 8.19453 9.28738C8.16461 9.25039 8.14356 9.20723 8.13292 9.16113C8.12229 9.11503 8.12236 9.06716 8.13312 9.02108L8.97963 5.36947C8.99249 5.31408 9.02036 5.26316 9.06028 5.22211C9.1002 5.18105 9.15067 5.1514 9.20634 5.13631C9.26201 5.12121 9.32079 5.12123 9.37645 5.13637C9.43211 5.1515 9.48256 5.18119 9.52245 5.22227L10.4732 6.20233ZM9.41143 10.8785C9.55927 10.9481 9.67431 11.0709 9.73279 11.2215C9.81659 11.4743 9.92964 11.7168 10.0697 11.9443C10.1161 12.015 10.1475 12.0941 10.1622 12.177C10.1768 12.2599 10.1745 12.3448 10.1552 12.4268C10.1359 12.5088 10.1001 12.5861 10.0499 12.6542C9.99974 12.7223 9.93616 12.7798 9.86298 12.8234C9.78979 12.8669 9.70848 12.8955 9.62385 12.9076C9.53921 12.9196 9.45299 12.9148 9.37027 12.8935C9.28754 12.8722 9.21001 12.8347 9.14225 12.7834C9.0745 12.7321 9.01789 12.6679 8.97579 12.5947C8.78507 12.2846 8.63145 11.9538 8.51801 11.609C8.47554 11.4532 8.49547 11.2874 8.57369 11.1457C8.65191 11.004 8.78245 10.8973 8.93834 10.8476C9.09424 10.7978 9.26359 10.8089 9.41143 10.8785ZM11.5518 13.2741C12.0106 13.4927 12.5125 13.6097 13.0223 13.6169H13.0255C13.1951 13.6181 13.3572 13.6856 13.4762 13.8045C13.5952 13.9233 13.6613 14.0838 13.6601 14.2507C13.6588 14.4175 13.5902 14.577 13.4694 14.6941C13.3486 14.8112 13.1855 14.8762 13.0159 14.875H13.0031C12.3069 14.8653 11.6214 14.7053 10.9949 14.4063C10.9178 14.3713 10.8485 14.3215 10.7911 14.2599C10.7338 14.1982 10.6895 14.126 10.6608 14.0473C10.6322 13.9686 10.6197 13.8851 10.6243 13.8016C10.6288 13.7181 10.6502 13.6364 10.6872 13.5612C10.7242 13.4859 10.7761 13.4187 10.8398 13.3634C10.9035 13.3081 10.9778 13.2659 11.0583 13.2391C11.1388 13.2124 11.2239 13.2017 11.3086 13.2077C11.3933 13.2137 11.476 13.2363 11.5518 13.2741ZM16.916 11.8556C16.7738 11.7648 16.6008 11.7332 16.4349 11.7679C16.2691 11.8026 16.1241 11.9006 16.0317 12.0405C15.7528 12.461 15.3851 12.8175 14.9538 13.086C14.8103 13.1752 14.7088 13.3167 14.6714 13.4796C14.6341 13.6425 14.664 13.8132 14.7546 13.9544C14.8453 14.0955 14.9892 14.1955 15.1547 14.2322C15.3202 14.269 15.4938 14.2395 15.6373 14.1503C16.226 13.7851 16.7276 13.2991 17.1078 12.7255C17.1533 12.656 17.1845 12.5784 17.1995 12.497C17.2144 12.4157 17.213 12.3322 17.1952 12.2514C17.1774 12.1706 17.1435 12.0941 17.0956 12.0262C17.0477 11.9582 16.9867 11.9003 16.916 11.8556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_998_100369",
    x: 0.5,
    y: 0,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_998_100369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_998_100369",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100ScreenOn);
export default __webpack_public_path__ + "static/media/100-screen-on.5ffbee7021fead3411cf4370199f5fe7.svg";
export { ForwardRef as ReactComponent };